<div class="terms-page">

  <!-- Header -->
  <header class="terms-header">
    <h1>Terms & Conditions</h1>
  </header>

  <main class="terms-content">

    <!-- Loader -->
    <div *ngIf="isLoading" class="loading-spinner">
      <div class="spinner"></div>
    </div>

    <!-- Terms -->
    <div *ngIf="!isLoading && termsContent?.sections?.length">
      <section *ngFor="let section of termsContent.sections; let sectionIndex = index">
        <h2 class="section-heading">{{ section.heading }}</h2>

        <div
          *ngFor="let subsection of section.subsections; let subsectionIndex = index"
          class="subsection-content"
        >
          <span class="numbering">{{ sectionIndex + 1 }}.{{ subsectionIndex + 1 }}</span>
          <span>{{ subsection.content }}</span>
        </div>
      </section>

      <!-- Agreement Section -->
      <div class="agreement-section">
        <label class="checkbox-wrapper">
          <input
            type="checkbox"
            [checked]="isAgreed"
            (change)="onTermsCheck($event)"
          />
          <span>I agree to the <strong>terms and conditions</strong></span>
        </label>

        <div class="otp-helper">
          Didn’t verify OTP? 
          <a (click)="onTermsCheck({ target: { checked: true } })">Click here to verify again</a>
        </div>

      </div>
    </div>

    <!-- Fallback -->
    <div *ngIf="!isLoading && !termsContent?.sections?.length" class="no-terms">
      <p class="error-text">No terms and conditions are available at the moment.</p>
    </div>
  </main>
</div>

